"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardControlStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var edit = function edit(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.728 6.68596L11.314 5.27196L2 14.586V16H3.414L12.728 6.68596ZM14.142 5.27196L15.556 3.85796L14.142 2.44396L12.728 3.85796L14.142 5.27196ZM4.242 18H0V13.757L13.435 0.321961C13.6225 0.13449 13.8768 0.0291748 14.142 0.0291748C14.4072 0.0291748 14.6615 0.13449 14.849 0.321961L17.678 3.15096C17.8655 3.33849 17.9708 3.5928 17.9708 3.85796C17.9708 4.12313 17.8655 4.37743 17.678 4.56496L4.243 18H4.242Z",
    fill: "#25253E"
  }));
};
edit.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var check = function check(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.33333 8.64332L12.9933 0.982483L14.1725 2.16082L5.33333 11L0.0300002 5.69665L1.20833 4.51832L5.33333 8.64332Z",
    fill: "#25253E"
  }));
};
check.defaultProps = {
  width: "15",
  height: "11",
  viewBox: "0 0 15 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var WizardControlStep = _styledComponents.default.div.attrs(function (_ref) {
  var step = _ref.step,
    currentStep = _ref.currentStep;
  return {
    children: !(step <= currentStep) ? /*#__PURE__*/_react.default.createElement(_ui.H6, {
      className: "mb-0"
    }, step + 1) : /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: currentStep === step ? edit : check,
      color: "secondary"
    })
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 36px;\n  width: 36px;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  cursor: default;\n  ", ";\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    currentStep = _ref2.currentStep,
    step = _ref2.step;
  return step <= currentStep ? theme.colors.success : theme.colors.secondaryShade;
}, function (_ref3) {
  var step = _ref3.step,
    currentStep = _ref3.currentStep,
    theme = _ref3.theme;
  return !(step <= currentStep) && "border: 1px solid ".concat(theme.colors.secondaryShade2);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiary;
});
exports.WizardControlStep = WizardControlStep;